module.exports = __webpack_public_path__ + "img/ips tools sin fondo.png";